/**
 * Palette for the Programs browse page, from the validated design
 * (`Affiliation - Programmes.dc.html`).
 *
 * Values reference `@fluenceur/theme` token names where an exact equivalent
 * exists (verified against `packages/theme/src/config.ts`):
 * ink #171715, inkMuted #777166, inkSubtle #A29B8D, softCream #F4F3EC,
 * navInactive #45423C, green.600 #178468. Everything else has no theme
 * equivalent yet and stays a literal hex, kept in this single file so a later
 * token promotion is a one-place swap. No shadows anywhere: depth comes from
 * borders + background contrast.
 */
export const browseColors = {
  // Surfaces
  cardBg: 'rgba(255, 255, 255, 0.72)',
  cardBorder: '#ece8de',
  cardBorderHover: '#ddd8cc',

  // Text
  heading: 'ink',
  subtitle: 'inkMuted',
  bodyText: 'inkMuted',
  textMuted: 'inkSubtle',

  // Primary button
  primaryBg: 'ink',
  primaryHoverBg: '#2a2925',
  primaryText: '#f6f3ec',

  // Avatar stack
  avatarRing: '#ffffff',
  avatarFallbackBg: '#E0D2BE',

  // Commission pill
  commissionBg: 'softCream',
  commissionBorder: '#ece8de',
  commissionIcon: 'inkMuted',
  commissionNote: 'inkSubtle',

  // Stats
  statLabel: 'inkSubtle',
  statValue: 'ink',
  revenueValue: 'green.600',

  // Footer actions
  footerBorder: '#f1ede4',
  actionBorder: '#ece8de',
  actionBg: '#ffffff',
  actionText: 'navInactive',
  actionHoverBg: 'softCream',
  arrowIcon: 'inkSubtle',
  arrowHoverBorder: '#c9c2b2',
  arrowHoverIcon: 'navInactive',
} as const;
